import { useMemo } from "react";
import { Box } from "@mui/system";
import makeStyles from "@mui/styles/makeStyles";

import StreamCardImagePreview from "components/CaseManagement/CaseStream/StreamCards/StreamCardImagePreview";
import styles from "assets/jss/default/components/diagnosisReportStreamCardStyle.js";
import { AttachmentDetail } from "interfaces/attachment";
import { ExistingAttachmentsList } from "components/Attachments/ExistingAttachmentsList";

const useStyles = makeStyles(styles);

export interface StreamCardAttachmentsProps {
  attachments?: AttachmentDetail[];
  eventId: number;
}

const isImageMimeType = (mimeType: string): boolean =>
  mimeType.startsWith("image");

export function StreamCardAttachments({
  attachments,
  eventId
}: StreamCardAttachmentsProps): JSX.Element {
  const classes = useStyles();

  const imageAttachments = useMemo(
    () =>
      attachments?.filter(attachment =>
        isImageMimeType(attachment?.original_file?.type)
      ),
    [attachments]
  );
  const fileAttachments = useMemo(
    () =>
      attachments?.filter(
        attachment => !isImageMimeType(attachment?.original_file?.type)
      ),
    [attachments]
  );

  if (!attachments || attachments.length === 0) {
    return <></>;
  }

  return (
    <>
      {imageAttachments && imageAttachments.length > 0 && (
        <div className={classes.imagesArea}>
          <StreamCardImagePreview files={imageAttachments} eventId={eventId} />
        </div>
      )}

      <Box>
        <ExistingAttachmentsList
          initialAttachments={fileAttachments ?? []}
          showUser={false}
        />
      </Box>
    </>
  );
}
